var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9933 3.71481L13.9936 3.715L19.7535 7.74493C19.7535 7.74496 19.7536 7.74498 19.7536 7.745C20.2228 8.07347 20.6671 8.61203 20.9945 9.23921C21.3219 9.86643 21.5102 10.5396 21.5102 11.1153V17.8953C21.5102 20.1692 19.6641 22.0153 17.3902 22.0153H6.61023C4.33778 22.0153 2.49023 20.1606 2.49023 17.8853V10.9853C2.49023 10.4509 2.66062 9.8118 2.95881 9.20618C3.25686 8.60083 3.6613 8.0722 4.08775 7.73957L4.08786 7.73949L9.09648 3.83056C9.0967 3.83039 9.09692 3.83022 9.09714 3.83005C10.434 2.79475 12.603 2.74073 13.9933 3.71481ZM12.0002 19.7653C12.6864 19.7653 13.2502 19.2015 13.2502 18.5153V15.5153C13.2502 14.8292 12.6864 14.2653 12.0002 14.2653C11.3141 14.2653 10.7502 14.8292 10.7502 15.5153V18.5153C10.7502 19.2015 11.3141 19.7653 12.0002 19.7653Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/home-selected.7ed20627a0bb40fbbb562df5fd0911aa.svg";
export { ForwardRef as ReactComponent };